import { InjectionToken } from '@angular/core';
import { IAngularMyDpOptions } from '@nodro7/angular-mydatepicker';

export const DATEPICKER_CONFIG = new InjectionToken<IAngularMyDpOptions>('DATEPICKER_CONFIG');

export const DATEPICKER_CONFIG_OBJECT: IAngularMyDpOptions = {
  dateFormat: 'dd.mm.yyyy',
  satHighlight: true,
  showWeekNumbers: true,
  dayLabels: { su: 'So', mo: 'Mo', tu: 'Di', we: 'Mi', th: 'Do', fr: 'Fr', sa: 'Sa' },
  monthLabels: {
    1: 'Jan',
    2: 'Feb',
    3: 'Mär',
    4: 'Apr',
    5: 'Mai',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Okt',
    11: 'Nov',
    12: 'Dez'
  }
};
